import { Component ,ViewChild, inject,ElementRef } from '@angular/core';
import { Options } from '@angular-slider/ngx-slider';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators ,FormArray} from '@angular/forms';
import { COMMA, ENTER,TAB } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
declare var $:any;
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { getLocalJSON } from '../../_helpers/storage.util';


@Component({
  selector: 'app-editsinglevideopost',
  templateUrl: './editsinglevideopost.component.html',
  styleUrls: ['./editsinglevideopost.component.scss']
})
export class EditsinglevideopostComponent {

  readonly separatorKeysCodes: number[] = [ENTER, COMMA,TAB];
  public dropdownSettings: IDropdownSettings;
  addOnBlur = true;
  fruits: any = [];
  announcer = inject(LiveAnnouncer);
  public videoUrl:any='';
  public GenderList:any=[];
  public Ids:any=localStorage.getItem('grw_content_id');
  public allmasterData:any={};
  public DetailData:any=[];
  public shoeView:boolean=false;
  public ingredianList:any=[];
  public loading:boolean = false;
  public submitted:boolean = false;
  public LevelLIst:any=[];
  public TypeList:any=[];
  public suitabilityList:any=[];
  public demographicList:any=[];
  public medicalList:any=[];
  public areasList:any=[];
  public contentpillerList:any=[];
  public albumList:any=[];
  public cookingList:any=[];
  public dietList:any=[];
  public dimendionList:any=[];
  public preprationList:any=[];
  public primaryList:any=[];
  public subprimaryList:any=[];
  public taglist:any=[];
  public otherSelection:any='';
  public m_otherSelection:any='';
  public ms_otherSelection:any='';
  public d_otherSelection:any='';
  public s_otherSelection:any='';
  public c_otherSelection:any='';
  public freeshowhide:any=false;
  public CycleList:any=[];
  public cycleChcek:any=false;
  public logGender:any='';
  public logGendername:any='';


  value: number = 1;
  options: Options = {
    step: 750,
    showTicksValues: false,    
    showTicks: true,
    stepsArray: [
      {value: 0, legend: 'Low'},
      {value: 1250, legend: 'Medium'},
      {value: 2500, legend: 'High'}
    ],
  };
  public freechcek:boolean=false;
  public userUpdatedImage: any;
  public imagePath: any;
  imgURL: any = "";
  public selectedFile: any = "";
  public selectedVidoe: any = "";
  public videoName: any = "";
  public videoSize: any = "";
  public mesage:any='';
  public EquipmentArray:any = [];
  public stepArray:any=[{id:1,text:'',textdisabled:true, checkdisabled:false}];
  public viewss:boolean=false;  
  public sliderArray:any=[];
  public subprimarySelected:any=[];
  public subprimaryname:any='';
  public TypeSelected:any=[];
  public Typename:any='';

  AllEditData = new FormGroup({
    albumName:new FormControl('',Validators.compose([
      Validators.required,Validators.maxLength(35)])),
    description:new FormControl('',Validators.compose([
      Validators.required ,Validators.maxLength(140) ,Validators.minLength(10)])),
      hours:new FormControl(0),
      minute:new FormControl(0),
      second:new FormControl(0), 
    types:new FormControl(''), 
    typeOther:new FormControl(''),         
    demographic:new FormControl('',Validators.compose([
      Validators.required])),
    diet: new FormControl(''),
    dimention :  new FormControl(''),
    gender:new FormControl(''),    
    contentpiller:new FormControl(''),    
    cookingTime:new FormControl(0),
    prepTime:new FormControl(0),   
    totalTime:new FormControl(0),
    primarycategory: new FormControl(''),
    sprimary:new FormControl(''), 
    others:new FormControl(''),
    m_others:new FormControl(''),
    ms_others:new FormControl(''),
    d_others:new FormControl(''),
    s_others:new FormControl(''),
    level:new FormControl(''),  
    balance:new FormControl(0),  
    cycle:new FormControl(''), 
  })  
  get f() { return this.AllEditData.controls; }


  constructor(private el: ElementRef,public router: Router, public service: GlobalService) {
    var mm:any =localStorage.getItem('grw_freevideo')
    if(mm==0 ){
      this.freeshowhide=true;
    }    
    this.getDetail();
    var ssd:any=getLocalJSON('grw_login');
    this.logGender=ssd.gender;
   
   }

   displayTags(updateTags:any) {
    // console.log(updateTags);
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.fruits.push({name: value});
    }
    event.chipInput!.clear();
  }

  remove(fruit: any): void {
    const index = this.fruits.indexOf(fruit);
    if (index >= 0) {
      this.fruits.splice(index, 1);
      this.announcer.announce(`Removed ${fruit}`);
    }
  }

  edit(fruit: any, event: any) {
    const value = event.value.trim();
    if (!value) {
      this.remove(fruit);
      return;
    }
    const index = this.fruits.indexOf(fruit);
    if (index >= 0) {
      this.fruits[index].name = value;
    }
  }

  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: "_id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 2,
      allowSearchFilter: true,
      limitSelection: 2,
    };
  }

  getDetail(){
    const url = "/single-post-detail?post_id="+this.Ids; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        var data:any =response.data[0];
        var self=this;
        if((data.post_type == 1 || data.post_type == 2 || data.post_type == 3) && data.post_category == 1  ){
          this.sliderArray=
          [ {id:1,name:'Balance',text:'balance', value:data.balance},
            {id:2,name:'Flexibility',text:'flexibility', value:data.flexibility},
            {id:3,name:'Focus',text:'focus', value:data.focus},
            {id:4,name:'Strength',text:'strength', value:data.strength},
            {id:5,name:'Endurance',text:'endurance', value:data.endurance},
          ];
          if(data.other_type.length != 0){
            data.type_other =data.other_type[0].content;
          }
          if(data.type.length != 0){
            data.type.filter((el:any)=>{
              if(el.childContent == true){
                self.otherSelection = el._id;             
              }
            })
            this.TypeSelected=data.type;
          }   
          if(data.content_pillar.length !=0){
            data.contentpiller = data.content_pillar[0]._id;
          } else {
            data.contentpiller = '';
          }
          if(data.post_equipment_sets_reps.length != 0){
            var count=1;
            data.post_equipment_sets_reps.filter((el:any)=>{
              self.EquipmentArray.push({id: count,equipment: el.equipment,sets: el.sets,reps:el.reps});
              count=count+1;
            })
          } else {
            self.EquipmentArray.push({id: 1,equipment: '',sets: '',reps:''});
          }
              
          if(data.medical_other.length != 0){
            data.medical_other =data.medical_other[0].content;
          }
          if(data.medical_condition.length != 0){
            data.medical_condition.filter((el:any)=>{
              if(el.childContent == true){
                self.m_otherSelection = el._id;
              }
              if(el.subchildContent == true){
                self.ms_otherSelection = el._id;
              }
            })
          }  
          this.AllEditData.controls["gender"].setValidators([Validators.required]);
          this.AllEditData.controls["gender"].updateValueAndValidity();
          this.AllEditData.controls["types"].setValidators([Validators.required]);
          this.AllEditData.controls["types"].updateValueAndValidity();
        }
        if((data.post_type == 1 || data.post_type == 2 || data.post_type == 3) && data.post_category == 2  ){
          // if(data.post_type == 1){
          //   this.sliderArray=
          //   [ {id:1,name:'Calories',text:'balance', value:data.avg_calories},
          //   ];
          // } 
          // if(data.post_type == 2){
          //   this.sliderArray=
          //   [ {id:1,name:'Calories',text:'balance', value:data.calories},
          //   ];
          // } 
          // if(data.post_type == 3){
          //   this.sliderArray=
          //   [ {id:1,name:'Calories',text:'balance', value:data.calories},
          //   ];
          // }

          if(data.primary_category.length != 0){
            data.primary_category_id =data.primary_category[0]._id;
          } else {
            data.primary_category_id ='';
          }
          if(data.diet_other.length != 0){
            data.diet_other =data.diet_other[0].content;
          }
          if(data.subcategory_other.length != 0){
            data.subcategory_other =data.subcategory_other[0].content;
          }
          if(data.diet.length != 0){
            data.diet.filter((el:any)=>{
              if(el.childContent == true){
                self.d_otherSelection = el._id;
              }
            })
          }
          if(data.sub_category.length != 0){
            data.sub_category.filter((el:any)=>{
              if(el.childContent == true){
                self.s_otherSelection = el._id;
              }
            })
            this.subprimarySelected=data.sub_category;
          }       
        }
        if((data.post_type == 1  && data.post_category == 2 ) || data.post_type == 3 || data.post_type == 2){
          if(data.post_steps.length !=0){
            self.stepArray=[];

          // var mm:any= data.steps.split(',');
          var count=1;  
          data.post_steps.filter((el:any)=>{
            self.stepArray.push({id :count,textdisabled: false,checkdisabled:false,text:el.steps})
            count=count+1; 
          })
        }  else {

        }
        }
        if(((data.post_type == 1  || data.post_type == 2 || data.post_type == 3 ) && data.post_category == 2 ) ){
          if(data.ingredients !=''){
          var jj:any= data.ingredients.split(',');
          jj.filter((el:any)=>{
            self.fruits.push(
              {name:el},)
          })
        }
        }      
        if(data.post_type == 1){
          this.freechcek = data.is_content_free;   
        }        
        if(data.content !='' ){
          // if(data.post_type==1 || data.post_type==3){
          //   this.videoUrl = this.service.playerBase+data.content +'-9fdkfJgJ.html';
          //   //  data.dimensions[0].player_id+'.html';       
          // } else {
            this.videoUrl = data.bunny_playback_url || data.content;
          // }
          data.content = this.videoUrl;
        } 
        
        if(data.thumbnail !=''){
          self.imgURL = data.thumbnail;       
        }  
        if( data.is_content_free==true){
          this.freeshowhide=false;
        }

        if((( data.post_type ==2) && data.post_category ==1)){
          if(data.doc_time==""){
            data.hour=0;
            data.minute=0;
            data.second=0;
          } else {
            var mm:any=data.doc_time.split(':');
            data.hour=mm[0];
            data.minute=mm[1];
            data.second=mm[2];
          }
       
        }

      
        this.DetailData = data;
        this.getAllMasterData();
      }
    }), (error) => { this.loading =false; });
  }

  getCheckboxexData(event:any,type:any){
    var subcatText: any='',self=this,count=0;
    if(type==1){
      this.medicalList.filter((el:any)=>{
        if(event.target.checked){
          if(event.target.value ==el._id && el.childContent==true){
            self.m_otherSelection =el._id;
          }
          if(event.target.value ==el._id && el.subchildContent==true){
            self.ms_otherSelection =el._id;
          }
          if(el._id == event.target.value){
            el.chcecked = true;
          }
        } else {
          if(event.target.value ==el._id && el.childContent==true){
            self.m_otherSelection ='';
          }
          if(event.target.value ==el._id && el.subchildContent==true){
            self.ms_otherSelection ='';
          }
          if(el._id == event.target.value){
            el.chcecked = false;
          }
        }        
      })
    } else if(type==2){
      this.suitabilityList.filter((el:any)=>{
        if(event.target.checked){  
          if(event.target.value == el._id ){
            if(el.multiSelect==true){
              self.suitabilityList.filter((ell:any)=>{
                ell.chcecked = true;
              })
              return;            
            } else{
              el.chcecked = true;
              return;
            }
          }    
        } else {   
          if(event.target.value == el._id ){ 
            self.suitabilityList.filter((el:any)=>{
              if(el.multiSelect==true && el.chcecked == true){
                self.suitabilityList.filter((ell:any)=>{
                  ell.chcecked = false;
                })
                return;
              } else{
                if(event.target.value == el._id ){
                  el.chcecked = false;
                }
                return;
              }
            })  
            return;         
          }
        }       
      })
    } else if(type==3){
      if (this.subprimarySelected.length != 0) {
        this.subprimarySelected.filter(function (el: any) {
          if (subcatText) {
            subcatText = el._id + " , " + subcatText;
          } else {
            subcatText = el._id;
          }       
          self.subprimaryList.filter((ell:any)=>{
            if(ell._id==el._id && ell.childContent==true){
              count =1;           
            }
          })
          if(count ==1){
            self.s_otherSelection =el._id;
          } else {
            self.s_otherSelection ='';
          }
        });
        
        if(subcatText !=''){
          this.subprimaryname= subcatText;
        }
      }    
    } else if(type==4){
      var ss=1;
      this.dietList.filter((el:any)=>{
        if(event.target.checked){
          if(event.target.value ==el._id && el.childContent==true){
            self.d_otherSelection =el._id;
          }
          if(el._id == event.target.value){
            el.chcecked = true;
          }
        } else {
          if(event.target.value ==el._id && el.childContent==true){
            self.d_otherSelection ='';
          }
          if(el._id == event.target.value){
            el.chcecked = false;
          }
        }        
      })
      this.dietList.filter((el:any)=>{
        if(el.chcecked){ss=0;
        this.AllEditData.controls["diet"].setValue(el._id); 
        }
      })
      if(ss==1){
        this.AllEditData.controls["diet"].setValue('');
      }
    } else if(type==5)  {
      if (this.TypeSelected.length != 0) {
        this.TypeSelected.filter(function (el: any) {
          if (subcatText) {
            subcatText = el._id + " , " + subcatText;
          } else {
            subcatText = el._id;
          }       
          self.TypeList.filter((ell:any)=>{
            if(ell._id==el._id && ell.childContent==true){
              count =1;           
            }
          })
          if(count ==1){
            self.otherSelection =el._id;
          } else {
            self.otherSelection ='';
          }
        });
        
        if(subcatText !=''){
          this.Typename= subcatText;
        }
      }
      // this.TypeList.filter((el:any)=>{
      //   if(event.target.checked){
      //     if(event.target.value ==el._id && el.childContent==true){
      //       self.otherSelection =el._id;
      //     }
      //     if(el._id == event.target.value){
      //       el.chcecked = true;
      //     }
      //   } else {
      //     if(event.target.value ==el._id && el.childContent==true){
      //       self.otherSelection ='';
      //     }
      //     if(el._id == event.target.value){
      //       el.chcecked = false;
      //     }
      //   }        
      // })
    } else if(type==6){
      this.LevelLIst.filter((el:any)=>{
        if(event.target.checked){  
          if(event.target.value == el._id ){
            if(el.multiSelect==true){
              self.LevelLIst.filter((ell:any)=>{
                ell.chcecked = true;
              })
              return;            
            } else{
              el.chcecked = true;
              return;
            }
          }    
        } else {   
          if(event.target.value == el._id ){ 
            self.LevelLIst.filter((el:any)=>{
              if(el.multiSelect==true && el.chcecked == true){
                self.LevelLIst.filter((ell:any)=>{
                  ell.chcecked = false;
                })
                return;
              } else{
                if(event.target.value == el._id ){
                  el.chcecked = false;
                }
                return;
              }
            })  
            return;         
            }
        }       
      })
    } else if(type==7){
      this.cookingList.filter((el:any)=>{
        if(event.target.id ==el._id && el.childContent==true){
          self.c_otherSelection =el._id;
        } 
        if(event.target.id ==el._id && el.childContent==false){
          self.c_otherSelection ='';
        }                 
    }) 
  } else  if(type==9){
    var ss=1;
    this.demographicList.filter((el:any)=>{
      if(event.target.checked){
        if(el._id == event.target.value){
          el.chcecked = true;
        }
      } else {
        if(el._id == event.target.value){
          el.chcecked = false;
        }
      }        
    })
      this.demographicList.filter((el:any)=>{
        if(el.chcecked){ss=0;
         this.AllEditData.controls["demographic"].setValue(el._id); 
        }
      })
      if(ss==1){
        this.AllEditData.controls["demographic"].setValue('');
      }
    } else {
        this.freechcek =event.target.checked;
    }
  }

  getsetData1(event:any,item:any,type:any){ 
    if(type == 1){
      if(event.target.checked){
        this.stepArray[item-1].textdisabled=false;
      } else {       
        this.stepArray[item-1].text='';
        this.stepArray[item-1].textdisabled=true;
      }
    } else {
      if( this.stepArray[item-1].text !=''){
        this.stepArray[item].checkdisabled=false;
      } else {
        this.stepArray[item].textdisabled=true;
        this.stepArray[item].checkdisabled=true;
      }      
    }  
  }

  getsetData(event:any,item:any){
    if(event.target.checked){
      this.stepArray[item-1].textdisabled=false;
    } else {       
      this.stepArray[item-1].text='';
      this.stepArray[item-1].textdisabled=true;
    }
}

  
  Onsavesubmit(type:any){
    this.loading=true;
    this.submitted = true;   
    var url="/wizard-single-post";
    var detail:any={};
    let userdetail :any={};
    userdetail.demo='';
    var count =0 ,count1=0 ,count2=0,count3=0;   
    if(this.DetailData.post_category==1){
      userdetail = this.AllEditData;
      userdetail.medical = '';  
      userdetail.equip=[];
      userdetail.sets=[];
      userdetail.reps=[];
      userdetail.steps = [];    
      this.medicalList.filter((el:any)=>{
        if(el.chcecked == true){
          if(el.childContent == true){
            userdetail.controls["m_others"].setValidators([Validators.required]);
            userdetail.controls["m_others"].updateValueAndValidity();
          }
          if(el.subchildContent  == true){
            userdetail.controls["ms_others"].setValidators([Validators.required]);
            userdetail.controls["ms_others"].updateValueAndValidity();
          } 
          if(count == 0){
            userdetail.medical = el._id ;
          } else {
            userdetail.medical = el._id +',' + userdetail.medical;
          } 
          count=count+1;          
        }        
      });
      this.medicalList.filter((el:any)=>{
        if(el.chcecked == false){
          if(el.childContent == true){
            userdetail.controls["m_others"].clearValidators();
            userdetail.controls["m_others"].updateValueAndValidity();
            userdetail.controls["m_others"].setValue('');
            }
        }        
      });
      if (this.EquipmentArray.length !=0)  {
        this.EquipmentArray.filter(function (el:any){
          if(el.equipment!= '' && el.sets== '' && el.reps == ''){
            count1 = 1;
          }
          if(el.equipment!= '' && el.sets!= '' && el.reps != ''){
            userdetail.equip.push(el.equipment);
            userdetail.sets.push(el.sets);
            userdetail.reps.push(el.reps);
          }
        })
              
      } 
      this.stepArray.filter((el:any)=>{
        if(el.text != ''){
          userdetail.steps.push(el.text) ;
        //   if(userdetail.steps==''){
        //     userdetail.steps=el.text ;
        //   } else {
        //     userdetail.steps=el.text +','+userdetail.steps;
        //   }
         }
      });    
      if(this.DetailData.post_type ==2){
        userdetail.controls["hours"].setValidators([Validators.required  ,Validators.min(0),Validators.max(23)]);
        userdetail.controls["hours"].updateValueAndValidity();
        userdetail.controls["minute"].setValidators([Validators.required ,Validators.min(0),Validators.max(59)]);
        userdetail.controls["minute"].updateValueAndValidity();
        userdetail.controls["second"].setValidators([Validators.required ,Validators.min(0),Validators.max(59)]);
        userdetail.controls["second"].updateValueAndValidity();
      }
      if(this.otherSelection !=''){
        userdetail.controls["others"].setValidators([Validators.required]);
        userdetail.controls["others"].updateValueAndValidity();
      } else {
        userdetail.controls["others"].clearValidators();
        userdetail.controls["others"].updateValueAndValidity();
        userdetail.controls["others"].setValue('');
      }
      detail={  
        'name':userdetail.value.albumName,
        'post_id':this.DetailData._id,      
        'description':userdetail.value.description,
        'levels':userdetail.value.level,
        'type':this.Typename,
        'type_other':userdetail.value.others,
        'gender':this.DetailData.gender_id,
        'female_cycle':this.DetailData.female_cycle,
        'content_pillar':userdetail.value.contentpiller,
        'balance':this.sliderArray[0].value,
        'strength':this.sliderArray[3].value,
        'flexibility':this.sliderArray[1].value,
        'endurance':this.sliderArray[4].value,
        'focus':this.sliderArray[2].value,       
        'medical_condition':userdetail.medical,
        'medical_other':userdetail.value.m_others,
        'medical_subtitle':userdetail.value.ms_others,
        // 'demographic':userdetail.value.demographic,
        'status':type,
      }  
      if(userdetail.steps.length ==0 && this.DetailData.post_type !=1){
        this.service.dangerAlert('Instructions are mandatory.');
        this.loading=false;
        return
      } else{
        detail.steps=userdetail.steps;
      } 
      if(this.EquipmentArray[0].equip != ''){
        detail.equipment=userdetail.equip;
        detail.sets=userdetail.sets;
        detail.reps=userdetail.reps;
      }   
      if(this.DetailData.post_type !=1){
        detail.doc_time=userdetail.value.hours +':' + userdetail.value.minute +':'+userdetail.value.second;
      } 
    } else {
      userdetail = this.AllEditData;   
      userdetail.diets = '';
      userdetail.steps = [];   
      userdetail.tags = '';  
       userdetail.controls["diet"].setValidators([Validators.required]);
        userdetail.controls["diet"].updateValueAndValidity(); 
      if(this.s_otherSelection !=''){
        userdetail.controls["s_others"].setValidators([Validators.required]);
        userdetail.controls["s_others"].updateValueAndValidity();
      }
      this.dietList.filter((el:any)=>{
        if(el.chcecked == true){
          if(el.childContent == true){
            userdetail.controls["d_others"].setValidators([Validators.required]);
            userdetail.controls["d_others"].updateValueAndValidity();
            }
          if(count2 == 0){
            userdetail.diets = el._id ;
          } else {
            userdetail.diets = el._id +',' + userdetail.diets;
          } 
          count2=count2+1;          
        }         
      });
      this.dietList.filter((el:any)=>{
        if(el.chcecked == false){
          if(el.childContent == true){
           userdetail.controls["d_others"].clearValidators();
           userdetail.controls["d_others"].updateValueAndValidity();     
           userdetail.controls["d_others"].setValue(''); 
          }
        }         
      });
      // if(this.subprimaryname == '' && userdetail.value.primarycategory==''){
      //   this.service.dangerAlert('Please Select Primary Category Or Sub Category Option');
      //   this.loading=false;
      //   return
      // }
      if(this.fruits.length !=0){
        this.fruits.filter((el:any)=>{
          if(count1==0){
            userdetail.tags = el.name;
          } else {
            userdetail.tags = el.name +','+userdetail.tags;
          }
          count1=count1+1;
        })
      }   

      this.stepArray.filter((el:any)=>{
        if(el.text != ''){
          userdetail.steps.push(el.text) ;
        }
      }); 
      detail={  
        'name':userdetail.value.albumName,      
        'description':userdetail.value.description,
        // 'diet':userdetail.diets,
        'diet_other':userdetail.value.d_others,
        'post_id':this.DetailData._id,
        'pre_time':userdetail.value.prepTime,
        'cooking_time':userdetail.value.cookingTime,
        'total_time':userdetail.value.totalTime,
        'primary_category':userdetail.value.primarycategory,
        'sub_category':this.subprimaryname,
        'subcategory_other':userdetail.value.s_others,
        'calories':userdetail.value.balance,
        // 'demographic':userdetail.value.demographic,
        'ingredients':userdetail.tags,
        'status':type,
      }    
      if(userdetail.steps.length ==0 && this.DetailData.post_type !=1){
        this.service.dangerAlert('Instructions are mandatory.');
        this.loading=false;
        return
      } else{
        detail.steps=userdetail.steps;
      }  

    }
    this.demographicList.filter((el:any)=>{
      if(el.chcecked == true){
        if(count3 == 0){
          userdetail.demo = el._id ;
        } else {
          userdetail.demo = el._id +',' + userdetail.demo;
        } 
        count3=count3+1;          
      }        
    });

    if(count3==0){
        userdetail.controls["demographic"].setValue('');
    } else{
      detail.demographic=userdetail.demo;
      userdetail.controls["demographic"].setValue(userdetail.demo);
    } 
    if(count2==0){
        userdetail.controls["diet"].setValue('');
    } else{
      detail.diet=userdetail.diets;
      userdetail.controls["diet"].setValue(userdetail.diets);
    } 
    if(this.DetailData.post_type !=2){
      detail.dimension=this.dimendionList[0]._id; 
      detail.is_content_free=this.freechcek;
    }
      this.service.PostApis(detail,url).subscribe(((response:any)=>{
        if(response.success ==1){           
          this.submitted = false;
          this.loading=false;
          this.router.navigate(['/singles']);
        } else {
          this.service.dangerAlert(response.message);
          this.loading=false;
        }
      }), (error:any) => {
      });
  }

  Onsubmit(type:any){
    this.loading=true;
    this.submitted = true;   
    var url="/wizard-single-post";
    var detail:any={};
    let userdetail :any={};
    var count =0 ,count1=0 ,count2=0,count3=0;   
    userdetail.demo='';
    if(this.DetailData.post_category==1){
      userdetail = this.AllEditData;
      userdetail.medical = '';  
      userdetail.equip=[];
      userdetail.sets=[];
      userdetail.reps=[];
      userdetail.steps = [];    
      this.medicalList.filter((el:any)=>{
        if(el.chcecked == true){
          if(el.childContent == true){
            userdetail.controls["m_others"].setValidators([Validators.required]);
            userdetail.controls["m_others"].updateValueAndValidity();
          }
          if(el.subchildContent  == true){
            userdetail.controls["ms_others"].setValidators([Validators.required]);
            userdetail.controls["ms_others"].updateValueAndValidity();
          } 
          if(count == 0){
            userdetail.medical = el._id ;
          } else {
            userdetail.medical = el._id +',' + userdetail.medical;
          } 
          count=count+1;          
        }        
      });
      this.medicalList.filter((el:any)=>{
        if(el.chcecked == false){
          if(el.childContent == true){
            userdetail.controls["m_others"].clearValidators();
            userdetail.controls["m_others"].updateValueAndValidity();
            userdetail.controls["m_others"].setValue('');
            }
        }        
      });
      if (this.EquipmentArray.length !=0)  {
        this.EquipmentArray.filter(function (el:any){
          if(el.equipment!= '' && el.sets== '' && el.reps == ''){
            count1 = 1;
          }
          if(el.equipment!= '' && el.sets!= '' && el.reps != ''){
            userdetail.equip.push(el.equipment);
            userdetail.sets.push(el.sets);
            userdetail.reps.push(el.reps);
          }
        })
              
      } 
      this.stepArray.filter((el:any)=>{
         if(el.text != ''){
                userdetail.steps.push(el.text) ;

        //   if(userdetail.steps==''){
        //     userdetail.steps=el.text ;
        //   } else {
        //     userdetail.steps=el.text +','+userdetail.steps;
        //   }
         }
      });    
      if(this.DetailData.post_type ==2){
        userdetail.controls["hours"].setValidators([Validators.required  ,Validators.min(0),Validators.max(23)]);
        userdetail.controls["hours"].updateValueAndValidity();
        userdetail.controls["minute"].setValidators([Validators.required ,Validators.min(0),Validators.max(59)]);
        userdetail.controls["minute"].updateValueAndValidity();
        userdetail.controls["second"].setValidators([Validators.required ,Validators.min(0),Validators.max(59)]);
        userdetail.controls["second"].updateValueAndValidity();
      }
      if(this.otherSelection !=''){
        userdetail.controls["others"].setValidators([Validators.required]);
        userdetail.controls["others"].updateValueAndValidity();
      } else {
        userdetail.controls["others"].clearValidators();
        userdetail.controls["others"].updateValueAndValidity();
        userdetail.controls["others"].setValue('');
      }
      detail={  
        'name':userdetail.value.albumName,
        'post_id':this.DetailData._id,      
        'description':userdetail.value.description,
        'levels':userdetail.value.level,
        'type':this.Typename,
        'type_other':userdetail.value.others,
        'gender':this.DetailData.gender_id,
        'female_cycle':this.DetailData.female_cycle,
        'content_pillar':userdetail.value.contentpiller,
        'balance':this.sliderArray[0].value,
        'strength':this.sliderArray[3].value,
        'flexibility':this.sliderArray[1].value,
        'endurance':this.sliderArray[4].value,
        'focus':this.sliderArray[2].value,       
        'medical_condition':userdetail.medical,
        'medical_other':userdetail.value.m_others,
        'medical_subtitle':userdetail.value.ms_others,
        // 'demographic':userdetail.value.demographic,
        'status':type,
      }  
      if(userdetail.steps.length ==0 && this.DetailData.post_type !=1){
        this.service.dangerAlert('Instructions are mandatory.');
        this.loading=false;
        return
      } else{
        detail.steps=userdetail.steps;
      } 
      if(this.EquipmentArray[0].equip != ''){
        detail.equipment=userdetail.equip;
        detail.sets=userdetail.sets;
        detail.reps=userdetail.reps;
      }   
      if(this.DetailData.post_type !=1){
        detail.doc_time=userdetail.value.hours +':' + userdetail.value.minute +':'+userdetail.value.second;
      } 
    } else {
      userdetail = this.AllEditData;   
      userdetail.diets = '';
      userdetail.steps = [];   
      userdetail.tags = ''; 
      userdetail.controls["diet"].setValidators([Validators.required]);
      userdetail.controls["diet"].updateValueAndValidity();  
      if(this.s_otherSelection !=''){
        userdetail.controls["s_others"].setValidators([Validators.required]);
        userdetail.controls["s_others"].updateValueAndValidity();
      }
      this.dietList.filter((el:any)=>{
        if(el.chcecked == true){
          if(el.childContent == true){
            userdetail.controls["d_others"].setValidators([Validators.required]);
            userdetail.controls["d_others"].updateValueAndValidity();
            }
          if(count2 == 0){
            userdetail.diets = el._id ;
          } else {
            userdetail.diets = el._id +',' + userdetail.diets;
          } 
          count2=count2+1;          
        }         
      });
      this.dietList.filter((el:any)=>{
        if(el.chcecked == false){
          if(el.childContent == true){
           userdetail.controls["d_others"].clearValidators();
           userdetail.controls["d_others"].updateValueAndValidity();     
           userdetail.controls["d_others"].setValue(''); 
          }
        }         
      });
      // if(this.subprimaryname == '' && userdetail.value.primarycategory==''){
      //   this.service.dangerAlert('Please Select Primary Category Or Sub Category Option');
      //   this.loading=false;
      //   return
      // }
      if(this.fruits.length !=0){
        this.fruits.filter((el:any)=>{
          if(count1==0){
            userdetail.tags = el.name;
          } else {
            userdetail.tags = el.name +','+userdetail.tags;
          }
          count1=count1+1;
        })
      }   

      this.stepArray.filter((el:any)=>{
        if(el.text != ''){
          userdetail.steps.push(el.text) ;
        //   if(userdetail.steps==''){
        //     userdetail.steps=el.text ;
        //   } else {
        //     userdetail.steps=el.text +','+userdetail.steps;
        //   }
        }
      }); 
      detail={  
        'name':userdetail.value.albumName,      
        'description':userdetail.value.description,
        // 'diet':userdetail.diets,
        'diet_other':userdetail.value.d_others,
        'post_id':this.DetailData._id,
        'pre_time':userdetail.value.prepTime,
        'cooking_time':userdetail.value.cookingTime,
        'totalTime':userdetail.value.totalTime,
        'primary_category':userdetail.value.primarycategory,
        'sub_category':this.subprimaryname,
        'subcategory_other':userdetail.value.s_others,
        'calories':userdetail.value.balance,
        // 'demographic':userdetail.value.demographic,
        'ingredients':userdetail.tags,
        'status':type,
      }    
      if(userdetail.steps.length ==0 && this.DetailData.post_type !=1){
        this.service.dangerAlert('Instructions are mandatory.');
        this.loading=false;
        return
      } else{
        detail.steps=userdetail.steps;
      }  

    } 
    this.demographicList.filter((el:any)=>{
      if(el.chcecked == true){
        if(count3 == 0){
          userdetail.demo = el._id ;
        } else {
          userdetail.demo = el._id +',' + userdetail.demo;
        } 
        count3=count3+1;          
      }        
    });

      if(count2==0){
        userdetail.controls["diet"].setValue('');
    } else{
      detail.diet=userdetail.diets;
      userdetail.controls["diet"].setValue(userdetail.diets);
    } 

    if(count3==0){
        userdetail.controls["demographic"].setValue('');
    } else{
      detail.demographic=userdetail.demo;
      userdetail.controls["demographic"].setValue(userdetail.demo);
    } 
    if(this.DetailData.post_type !=2){
      detail.dimension=this.dimendionList[0]._id; 
      detail.is_content_free=this.freechcek;
    }

    if(userdetail.valid){           
      this.service.PostApis(detail,url).subscribe(((response:any)=>{
        if(response.success ==1){           
          this.submitted = false;
          this.loading=false;
          this.router.navigate(['/singles']);
        } else {
          this.service.dangerAlert(response.message);
          this.loading=false;
        }
      }), (error:any) => {
      });
    } else{
      const invalidControls: string[] = [];
      Object.keys(userdetail.controls).forEach((controlName) => {
        const control = userdetail.get(controlName);
        if (control && control.invalid) {
          invalidControls.push(controlName);
        }
      });
      if(invalidControls.length >1){
        this.service.dangerAlert('Please complete mandatory sections.');
      } else {
        var ss='';
        if(invalidControls[0]=='contentpiller'){
          ss='Content piller';
        }  else if(invalidControls[0]=='demographic'){
          ss='Demographic';
           }  else if(invalidControls[0]=='diet'){
          ss='Diet';
        }
        else if(invalidControls[0]=='balance'){
          ss='Calories';
        }
        else if(invalidControls[0]=='totalTime'){
          ss='Total Time';
        }
        else if(invalidControls[0]=='prepTime'){
          ss='Prep Time';
        }
        else if(invalidControls[0]=='cookingTime'){
          ss='Cooking Time';
        // }
        // else if(invalidControls[0]=='primarycategory'){
        //   ss='Primary Category';
        } else if(invalidControls[0]=='sprimary'){
          ss='Type';
        }
       else if(invalidControls[0]=='d_others'){
        ss='Diet Other';
      }
      else if(invalidControls[0]=='keywords'){
        ss='Tags';
      }
      else if(invalidControls[0]=='m_others'){
        ss='Medical Other';
      }
      else if(invalidControls[0]=='others'){
        ss='Type Other';
      }
      else if(invalidControls[0]=='level'){
        ss='Level';
      } else if(invalidControls[0]=='description'){
        ss='Description';
      } else if(invalidControls[0]=='albumName'){
        ss='Title';
      } else if(invalidControls[0]=='gender'){
        ss='Gender';
      } else {
        ss=invalidControls[0];
      }     
        this.service.dangerAlert(ss +' is required.');
      }
      this.loading = false
      userdetail.markAllAsTouched();
      this.scrollToFirstInvalidControl();  
    } 
  }
  getAllMasterData(){
    var self=this ,ss:any=[],dd:any=[];
    self.DetailData.gender_id='';
    self.DetailData.area_id='';
    self.DetailData.level_id='';
    self.DetailData.suitable_id='';
    const url = "/common-contents"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {  
        this.allmasterData=response.data;
    this.allmasterData.type.filter((el:any)=>{
      if(el.childContent==false){
        ss.push(el);
      } else {
        dd=el;
      }
      el.chcecked = false;
      if((self.DetailData.post_type==1 || self.DetailData.post_type==2 || self.DetailData.post_type==3)  && self.DetailData.post_category==1){
        self.DetailData.type.filter((ell:any)=>{
          if(ell._id ==el._id){
            el.chcecked= true;
          }
        })
      }
    });
    ss.push(dd);
    this.allmasterData.type =ss;
    ss=[],dd=[];
    this.allmasterData.medical.filter((el:any)=>{
      if(el.childContent==false){
        ss.push(el);
      } else {
        dd=el;
      }
      el.chcecked = false;
        self.DetailData.medical_condition.filter((ell:any)=>{
          if(ell._id ==el._id){
            el.chcecked= true;
          }
        })
    });
    ss.push(dd);
    this.allmasterData.medical =ss;
    ss=[],dd=[];
    this.allmasterData.levels.filter((el:any)=>{
      el.chcecked = false;
      if((self.DetailData.post_type==1 || self.DetailData.post_type==2 || self.DetailData.post_type==3) && self.DetailData.post_category==1){
        self.DetailData.levels.filter((ell:any)=>{
          if(ell._id ==el._id){
            el.chcecked= true;
            self.DetailData.level_id=el._id;
          }
        })
      }
    });
    this.allmasterData.sub_category.filter((el:any)=>{
      if(el.childContent==false){
        ss.push(el);
      } else {
        dd=el;
      }
      el.chcecked = false;
      if((self.DetailData.post_type==1 || self.DetailData.post_type==2 || self.DetailData.post_type==3)  && self.DetailData.post_category==2){
        self.DetailData.sub_category.filter((ell:any)=>{
          if(ell._id ==el._id){
            el.chcecked= true;
          }
        })
      }
    });
    ss.push(dd);
    this.allmasterData.sub_category =ss;
    ss=[],dd=[];
    this.allmasterData.diet.filter((el:any)=>{
      if(el.childContent==false){
        ss.push(el);
      } else {
        dd=el;
      }
      el.chcecked = false;

      if((self.DetailData.post_type==1 || self.DetailData.post_type==2 || self.DetailData.post_type==3)  && self.DetailData.post_category==2){
        self.DetailData.diet.filter((ell:any)=>{
          if(ell._id ==el._id){
            el.chcecked= true;
          }
        })
      }
    })
    ss.push(dd);
    this.allmasterData.diet =ss;
    ss=[],dd=[];
    this.allmasterData.genders.filter((el:any)=>{
      // if(el._id ==self.logGender){
      //   if(el.is_cycle==true){
      //     self.cycleChcek=true;
      //   } else {
      //     self.cycleChcek=false;
      //   }
      // }
      // if(el.name!='Other' && el.name!='other'){
      //   ss.push(el);
      // } else {
      //   dd=el;
      // }
      el.chcecked = false;
      if((self.DetailData.post_type==1 || self.DetailData.post_type==2 || self.DetailData.post_type==3)  && self.DetailData.post_category==1){
        if(self.DetailData.gender.length !=0){
          self.DetailData.gender.filter((ell:any)=>{
            if(ell._id ==el._id){
              el.chcecked= true;
              self.DetailData.gender_id=el._id;
              self.AllEditData.controls['gender'].setValue(el._id);
            }
          })
        }
     
      }
    })
    // ss.push(dd);
    // this.allmasterData.genders =ss;
    ss=[],dd=[];
    this.allmasterData.demographic.filter((el:any)=>{
      el.chcecked = false;
      // if(self.DetailData.post_type==1 && self.DetailData.post_category==1){
        if(self.DetailData.demographics.length !=0){
          self.DetailData.demographics.filter((ell:any)=>{
            if(ell._id ==el._id){
              el.chcecked= true;
            }
          })
        }
      // }
    })
    this.allmasterData.cooking_times.filter((el:any)=>{
      if(el.childContent==false){
        ss.push(el);
      } else {
        dd=el;
      }
      el.chcecked = false;
    })
    ss.push(dd);
    this.allmasterData.cooking_times =ss;
    ss=[],dd=[];
        this.LevelLIst = this.allmasterData.levels;
        this.GenderList = this.allmasterData.genders;
        this.CycleList = this.allmasterData.female_cycle;
        this.contentpillerList = this.allmasterData.content_pillars;         
        this.TypeList = this.allmasterData.type;
        this.suitabilityList = this.allmasterData.suitability;
        this.medicalList = this.allmasterData.medical;
        this.areasList = this.allmasterData.location;
        this.cookingList = this.allmasterData.cooking_times; 
        this.dietList = this.allmasterData.diet; 
        this.preprationList = this.allmasterData.preparation_times; 
        this.primaryList = this.allmasterData.primary_category; 
        this.subprimaryList = this.allmasterData.sub_category; 
        this.dimendionList = this.allmasterData.dimension;
        this.demographicList =this.allmasterData.demographic;
        if(this.DetailData.post_type == 1 && this.DetailData.post_category ==1){
          // this.AllEditData.controls["dimention"].setValidators([Validators.required]);
          // this.AllEditData.controls["dimention"].updateValueAndValidity();
          this.AllEditData.controls["contentpiller"].setValidators([Validators.required]);
          this.AllEditData.controls["contentpiller"].updateValueAndValidity();
          this.AllEditData.controls["level"].setValidators([Validators.required]);
          this.AllEditData.controls["level"].updateValueAndValidity();
        } 
        if(this.DetailData.post_type == 1 && this.DetailData.post_category ==2){
          // this.AllEditData.controls["dimention"].setValidators([Validators.required]);
          // this.AllEditData.controls["dimention"].updateValueAndValidity();
          this.AllEditData.controls["cookingTime"].setValidators([Validators.required ,Validators.max(999),Validators.min(0)]);
          this.AllEditData.controls["cookingTime"].updateValueAndValidity();
          this.AllEditData.controls["prepTime"].setValidators([Validators.required ,Validators.max(999),Validators.min(0)]);
          this.AllEditData.controls["prepTime"].updateValueAndValidity();
          this.AllEditData.controls["totalTime"].setValidators([Validators.required ,Validators.max(999),Validators.min(0)]);
          this.AllEditData.controls["totalTime"].updateValueAndValidity();
          // this.AllEditData.controls["primarycategory"].setValidators([Validators.required]);
          // this.AllEditData.controls["primarycategory"].updateValueAndValidity();
        }
        if(this.DetailData.post_type ==2 && this.DetailData.post_category ==1){
          this.AllEditData.controls["hours"].setValidators([
            Validators.required,Validators.min(0),Validators.max(23)]);
          this.AllEditData.controls["hours"].updateValueAndValidity();
          this.AllEditData.controls["minute"].setValidators([
            Validators.required,Validators.min(0),Validators.max(59)]);
          this.AllEditData.controls["minute"].updateValueAndValidity();
          this.AllEditData.controls["second"].setValidators([
            Validators.required,Validators.min(0),Validators.max(59)]);
          this.AllEditData.controls["second"].updateValueAndValidity();
          this.AllEditData.controls["contentpiller"].setValidators([Validators.required]);
          this.AllEditData.controls["contentpiller"].updateValueAndValidity();
          this.AllEditData.controls["level"].setValidators([Validators.required]);
          this.AllEditData.controls["level"].updateValueAndValidity();
        }
        if(this.DetailData.post_type ==3 && this.DetailData.post_category ==1){
          // this.AllEditData.controls["hours"].setValidators([
          //   Validators.required,Validators.min(0),Validators.max(23)]);
          // this.AllEditData.controls["hours"].updateValueAndValidity();
          // this.AllEditData.controls["minute"].setValidators([
          //   Validators.required,Validators.min(0),Validators.max(59)]);
          // this.AllEditData.controls["minute"].updateValueAndValidity();
          // this.AllEditData.controls["second"].setValidators([
          //   Validators.required,Validators.min(0),Validators.max(59)]);
          // this.AllEditData.controls["second"].updateValueAndValidity();
          this.AllEditData.controls["contentpiller"].setValidators([Validators.required]);
          this.AllEditData.controls["contentpiller"].updateValueAndValidity();
          this.AllEditData.controls["level"].setValidators([Validators.required]);
          this.AllEditData.controls["level"].updateValueAndValidity();
        }
        if(this.DetailData.post_type ==3 && this.DetailData.post_category ==2){
          // this.AllEditData.controls["keywords"].setValidators([Validators.required]);
          // this.AllEditData.controls["keywords"].updateValueAndValidity();
        }
        this.shoeView=true;
        this.viewss= true;
      }
    }), (error) => { this.loading =false; });
  }

  delete(){
    const url = "/post-delete?post_id="+this.Ids; 
    this.service.DeleteApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        $('#DeletePopup13').modal('toggle');
        this.router.navigate(['/singles']);
      }
    }), (error) => { this.loading =false; });
  }

  submitApproval(event:any){
    var mm :any='';
    mm= event.target.value;
    const url = "/state?country="+mm ; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
      }
    }), (error) => { this.loading =false; });
  }



  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      "form .ng-invalid"
    );
    // firstInvalidControl.focus(); //without smooth behavior
    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: "smooth"
    });
  }
  
  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

  wordCounter(){
    var self=this;
    var value = $('#Description').val();
    if (value.length == 0) {
      return;
    }
    var regex = /\s+/gi;
    var wordCount = value.trim().replace(regex, ' ').split(' ').length;
    self.mesage = wordCount;
  }

  Addmore(type:any){
    if(type ==1){
      if(this.EquipmentArray[this.EquipmentArray.length-1].equipment!='' && this.EquipmentArray[this.EquipmentArray.length-1].sets!='' && this.EquipmentArray[this.EquipmentArray.length-1].sets!=null && this.EquipmentArray[this.EquipmentArray.length-1].sets <=999  && this.EquipmentArray[this.EquipmentArray.length-1].reps!='' && this.EquipmentArray[this.EquipmentArray.length-1].reps!=null  && this.EquipmentArray[this.EquipmentArray.length-1].reps<=999){
        if(this.EquipmentArray.length <= 10){
          this.EquipmentArray.push({
            id: this.EquipmentArray.length + 1,
            equipment: '',
            sets: '',
            reps:'',
          });
        }
      }
    } else {
      var size:any=''
      if(this.DetailData.post_type==1 && this.DetailData.post_category ==2){
        size=10;
      } else {
        size=5;
      }
      if(this.stepArray[this.stepArray.length-1].text!='' ){
        if(this.stepArray.length <= size){
          this.stepArray.push({
            id: this.stepArray.length + 1,
            text:'',
            textdisabled:true,
            checkdisabled:false
          });
        }
      }
    }
  
  }
  
  removeItem(item:any,type:any){  
      var arr:any = [] ;
      var count=1;
      if(type == 1){
        this.EquipmentArray.filter((el:any)=>{
          if(el.id != item){
            el.id= count;
            arr.push(el);
            count=count+1;
          }
        })
        this.EquipmentArray = arr;
      } else {
        this.stepArray.filter((el:any)=>{
          if(el.id != item){
            el.id= count;
            arr.push(el);
            count=count+1;
          }
        })
        this.stepArray = arr;
      }
   
  }
  
  updateStatus(){
  var url="/single-post-update-status?post_id=" +this.Ids;
  this.service.GetApi(url).subscribe(((response:any)=>{
    if(response.success){
      this.service.successAlert(response.message);  
      this.getDetail();    
    } else {
      this.service.dangerAlert(response.message);   
    }
  }))
  }

  redirection(){
    localStorage.setItem('grw_upload_Data',JSON.stringify(this.DetailData)) 
    this.router.navigate(['/update-post']);
  }

  onFilterChange(event: any, type: any) { }

  getChaecks(event:any,type:any){
    var self=this;
    if(type==1){
      this.GenderList.filter((el:any)=>{
        if(el._id == event.target.id){
          if(el._id ==self.logGender){
            self.logGendername=el.name;
          }
          if(el._id ==self.logGender){
            if(el.is_cycle==true){
              self.cycleChcek=true;
            } else {
              self.cycleChcek=false;
            }
          }  else {
            if(self.logGendername =='female' ||  self.logGendername =='Female' ||  self.logGendername =='Non-binary' || self.logGendername =='non-binary' ){
              if(el.is_cycle==true){
                self.cycleChcek=true;
              } else {
                self.cycleChcek=false;
              }
            } else {
              self.cycleChcek=false;
            }
          }
          el.checked=true;
        } else {
          el.checked=false;
        }
      })
    } else {
      this.CycleList.filter((el:any)=>{
        if(el._id == event.target.id){
          if(el.chcecked==true){
            $("#"+event.target.id).prop("checked", false); 
            el.chcecked=false;
            self.AllEditData.controls['cycle'].setValue('');
          } else {
            $("#"+event.target.id).prop("checked", true); 
            el.chcecked=true;
          }
         
        } else {
          el.checked=false;
        }
  
      })
    }
  
  }
}

